import { defineMessages } from "react-intl";

export const createReturnsLabels = defineMessages({
  internationalShipmentWarning: {
    id: "returns.createReturnsLabels.internationalShipmentWarning",
    defaultMessage: "Returns only supported for US orders",
  },
});
